module.exports = __webpack_public_path__ + "img/profile.68f84899.svg";